import MainLayout from "../../layout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import DeleteModal from "../../components/modal/delete-modal";
import { TextView } from "../../components/view-form-components/text-view";
import { useEffect } from "react";
import { ImageView } from "../../components/view-form-components/image.view";
import CommentsComponent from "../../components/comments/comments";
import FileCommentComponent from "../../components/comments/file-comment";
import { api } from "../../redux/apis/api";
import { useRole } from "../../context/role/RoleContext";
import ShareModal from "../../components/modal/share-modal";

const ViewCompany = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useRole();
  const permission = state?.role?.company;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [shareModalShow, setShareModalShow] = useState(false);

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/company/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteFnc = (id) => {
    api
      .post(`/company/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate("/company/list");
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
      />
      <ShareModal
        isOpen={shareModalShow}
        onClose={() => {
          setShareModalShow(false);
        }}
        moduleName="company"
        modulelabel="company"
      />
      <section className="h-full overflow-auto px-3">
        <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <h2 className="text-xl font-semibold capitalize">company - view</h2>
          <div className="flex gap-3 items-center">
            {permission?.write && (
              <button
                onClick={() => {
                  setShareModalShow(true);
                }}
                className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
              >
                share
              </button>
            )}
            {permission?.write && (
              <Link
                className="px-4 py-2 bg-blue-600 text-white rounded"
                to={`/company/edit/${params?.id}`}
              >
                edit
              </Link>
            )}
            {permission?.write && (
              <button
                onClick={() => {
                  setdeleteModalShow(true);
                }}
                className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
              >
                Delete
              </button>
            )}
          </div>
        </div>
        <section className="w-full max-w-[40rem]">
          <div className="px-2">
            <ImageView label={"logo"} value={data?.logo} />
            <TextView label={"Name"} value={data?.name ?? "--"} />
            <TextView label={"Email"} value={data?.email ?? "--"} />
            <TextView
              label={"phone_number"}
              value={data?.phone_number ?? "--"}
            />
            <TextView label={"address"} value={data?.address ?? "--"} />
            <TextView label={"state"} value={data?.state?.name ?? "--"} />
            <TextView label={"city"} value={data?.city?.name ?? "--"} />
            <TextView label={"pan number"} value={data?.pan_number ?? "--"} />
            <TextView label={"gst number"} value={data?.gst_number ?? "--"} />
          </div>
        </section>
        <div className="bg-[#1D72DB60] rounded-[4px] px-4 py-1 my-5">
          <p>Bank Details</p>
        </div>
        <section className="w-full max-w-[40rem]">
          <TextView label={"bank name"} value={data?.bank_name ?? "--"} />
          <TextView
            label={"bank account number"}
            value={data?.bank_account_number ?? "--"}
          />
          <TextView
            label={"bank ifsc code"}
            value={data?.bank_ifsc_code ?? "--"}
          />
          <TextView
            label={"bank account holder name"}
            value={data?.bank_account_holder_name ?? "--"}
          />
          <TextView label={"upi id"} value={data?.upi_id ?? "--"} />
        </section>
        <CommentsComponent tableName={"company"} viewId={params?.id} />
        <FileCommentComponent tableName={"company"} viewId={params?.id} />
      </section>
    </MainLayout>
  );
};

export default ViewCompany;
